import { useCallback } from 'react';
import isSSR from '../../../utils/isSSR';
import { BUILD_AND_PRICE_URL } from '../../../utils/constants';
import { useSharedApps } from '../../../utils/sitecoreContext';
export var useLanguageLinkUrl = function () {
    var bapUrl = useSharedApps(BUILD_AND_PRICE_URL);
    var formatUrl = useCallback(function (languageLinkUrl) {
        var currentUrlPath = isSSR() ? '' : window.location.pathname;
        var languageLinkUrlParts = languageLinkUrl.split('/');
        var currentUrlPathParts = currentUrlPath.split('/');
        var bapUrlParts = bapUrl.split('/');
        if (languageLinkUrlParts[2] === bapUrlParts[2] || currentUrlPathParts[2] === bapUrlParts[2]) {
            return "/".concat(languageLinkUrlParts[1], "/").concat(languageLinkUrlParts[2]);
        }
        return languageLinkUrl;
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return formatUrl;
};
export default useLanguageLinkUrl;
